<template>
  <div class="product-form-container">
    <!-- 全局加载遮罩层 -->
    <div class="loading-mask" v-if="loading">
      <div class="loading-spinner"></div>
    </div>
    <!-- 表单主体 -->
    <div class="form-wrapper">
      <h1 class="panel-title">样衣修改</h1>
      <!-- 左侧表单区域 -->
      <div class="form-left">
        <!-- 样衣编号 -->
        <div class="form-item single-item">
          <label>样衣编号:</label>
          <input
            style="width: 150px"
            type="text"
            v-model="formData.productCode"
            placeholder="请输入样衣编号"
          />
          <label>类别:</label>
          <el-select
            v-model="formData.categoryId"
            placeholder="请选择类别"
            multiple
            collapse-tags
            clearable
            style="padding: 12px"
            :style="{ borderBottom: 'none' }"
          >
            <el-option
              v-for="option in leilist"
              :key="option.id"
              :label="option.name"
              :value="option.id"
            />
          </el-select>
        </div>
        <!-- 面料信息分组 -->
        <div class="fabric-group">
          <div class="group-title">面料信息：</div>
          <div class="form-item single-item">
            <label>品名/编号:</label>
            <el-select
              v-model="formData.productpm"
              placeholder="请选择品名编号"
              filterable
              @change="watchs(formData.productpm)"
              style="padding: 12px"
              :style="{ borderBottom: 'none' }"
            >
              <el-option
                v-for="option in lists"
                :key="option.id"
                :label="option.name"
                :value="option.name"
              />
            </el-select>
          </div>
          <!-- 两行两列布局：幅宽/克重、成份/类别 -->
          <div class="form-row">
            <div class="form-item">
              <label>幅宽:</label>
              <input disabled type="text" v-model="formData.width" />
            </div>
            <div class="form-item">
              <label>克重:</label>
              <input disabled type="text" v-model="formData.weight" />
            </div>
          </div>
          <div class="form-row">
            <div class="form-item">
              <label>成份:</label>
              <input disabled type="text" v-model="formData.composition" />
            </div>
            <div class="form-item">
              <label>面料类别:</label>
              <el-tooltip :content="formData.texts" placement="top">
                <input disabled type="text" v-model="formData.texts" />
              </el-tooltip>
            </div>
          </div>
          <div class="form-row">
            <div class="form-item">
              <label>量化:</label>
              <input disabled type="text" v-model="formData.quantify" />
            </div>
            <div class="form-item">
              <label>备注:</label>
              <input disabled type="text" v-model="formData.remark" />
            </div>
          </div>
          <div class="form-row">
            <div class="form-item">
              <label>纱支:</label>
              <input disabled type="text" v-model="formData.yarnCount" />
            </div>
            <div class="form-item">
              <label>密度:</label>
              <input disabled type="text" v-model="formData.density" />
            </div>
          </div>
          <div class="form-row">
            <div class="form-item">
              <label>规格:</label>
              <input disabled type="text" v-model="formData.specification" />
            </div>
          </div>
        </div>
      </div>
      <!-- 右侧上传区域 -->
      <div class="form-right">
        <!-- 封面图上传 - 单个 -->
        <div class="upload-section">
          <h4>
            封面图<span style="font-size: 14px; color: #999"
              >（图片比例宽高3:4，单张图片不能超过1MB）</span
            >
          </h4>
          <div class="upload-boxes">
            <div class="upload-box" @click="handleUpload('cover', null)">
              <img
                v-if="previewUrls['cover'] && !deletedCover"
                :src="previewUrls['cover']"
                class="uploaded-img"
              />
              <div
                v-if="previewUrls['cover'] && !deletedCover"
                class="img-mask-edit"
              >
                <div
                  class="mask-btn"
                  @click.stop="openImagePreview(previewUrls['cover'])"
                >
                  <svg
                    width="22"
                    height="22"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="#fff"
                    stroke-width="2"
                  >
                    <path
                      d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"
                    ></path>
                    <circle cx="12" cy="12" r="3"></circle>
                  </svg>
                  <span class="edit-tip-text">预览</span>
                </div>
                <div class="mask-btn" @click.stop="handleUpload('cover', null)">
                  <svg
                    width="22"
                    height="22"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="#61b88e"
                    stroke-width="2"
                  >
                    <path d="M12 20h9"></path>
                    <path
                      d="M16.5 3.5a2.121 2.121 0 0 1 3 3L7 19l-4 1 1-4L16.5 3.5z"
                    ></path>
                  </svg>
                  <span class="edit-tip-text">修改</span>
                </div>
              </div>
              <div
                v-if="previewUrls['cover']"
                class="img-delete-btn"
                @click.stop="handleDeleteImage('cover', null)"
              >
                ×
              </div>
              <span v-else>+</span>
            </div>
          </div>
        </div>
        <!-- 详情图上传 -->
        <div class="upload-section">
          <h4>
            详情图<span style="font-size: 14px; color: #999"
              >（最多5张，单张图片不能超过1MB）</span
            >
          </h4>
          <div class="upload-container">
            <!-- 新增按钮：小于5张才显示 -->
            <div
              v-if="validDetails.length < 5"
              class="add-btn upload-box"
              @click="handleUpload('detail', null)"
            >
              <span>+</span>
            </div>
            <!-- 图片展示区（支持拖拽） -->
            <div class="img-show-wrap">
              <div
                class="upload-box img-item"
                v-for="item in validDetails"
                :key="item._uid"
                draggable="true"
                @dragstart="handleDragStart($event, item, 'detail')"
                @dragover.prevent
                @drop="handleDrop($event, item, 'detail')"
                @click="handleUpload('detail', item)"
              >
                <img :src="item.url" class="uploaded-img" />
                <div class="img-mask-edit">
                  <div
                    class="mask-btn"
                    @click.stop="openImagePreview(item.url)"
                  >
                    <svg
                      width="22"
                      height="22"
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="#fff"
                      stroke-width="2"
                    >
                      <path
                        d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"
                      ></path>
                      <circle cx="12" cy="12" r="3"></circle>
                    </svg>
                    <span class="edit-tip-text">预览</span>
                  </div>
                  <div
                    class="mask-btn"
                    @click.stop="handleUpload('detail', item)"
                  >
                    <svg
                      width="22"
                      height="22"
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="#61b88e"
                      stroke-width="2"
                    >
                      <path d="M12 20h9"></path>
                      <path
                        d="M16.5 3.5a2.121 2.121 0 0 1 3 3L7 19l-4 1 1-4L16.5 3.5z"
                      ></path>
                    </svg>
                    <span class="edit-tip-text">修改</span>
                  </div>
                </div>
                <div
                  class="img-delete-btn"
                  @click.stop="handleDeleteImage('detail', item)"
                >
                  ×
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- 电子色卡上传 -->
        <div class="upload-section">
          <h4>
            电子色卡<span style="font-size: 14px; color: #999"
              >（最多5张，单张图片不能超过1.3MB）</span
            >
          </h4>
          <div class="upload-container">
            <!-- 新增按钮：小于5张才显示 -->
            <div
              v-if="validColors.length < 5"
              class="add-btn upload-box"
              @click="handleUpload('color', null)"
            >
              <span>+</span>
            </div>
            <!-- 图片展示区（支持拖拽） -->
            <div class="img-show-wrap">
              <div
                class="upload-box img-item"
                v-for="item in validColors"
                :key="item._uid"
                draggable="true"
                @dragstart="handleDragStart($event, item, 'color')"
                @dragover.prevent
                @drop="handleDrop($event, item, 'color')"
                @click="handleUpload('color', item)"
              >
                <img :src="item.url" class="uploaded-img" />
                <div class="img-mask-edit">
                  <div
                    class="mask-btn"
                    @click.stop="openImagePreview(item.url)"
                  >
                    <svg
                      width="22"
                      height="22"
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="#fff"
                      stroke-width="2"
                    >
                      <path
                        d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"
                      ></path>
                      <circle cx="12" cy="12" r="3"></circle>
                    </svg>
                    <span class="edit-tip-text">预览</span>
                  </div>
                  <div
                    class="mask-btn"
                    @click.stop="handleUpload('color', item)"
                  >
                    <svg
                      width="22"
                      height="22"
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="#61b88e"
                      stroke-width="2"
                    >
                      <path d="M12 20h9"></path>
                      <path
                        d="M16.5 3.5a2.121 2.121 0 0 1 3 3L7 19l-4 1 1-4L16.5 3.5z"
                      ></path>
                    </svg>
                    <span class="edit-tip-text">修改</span>
                  </div>
                </div>
                <div
                  class="img-delete-btn"
                  @click.stop="handleDeleteImage('color', item)"
                >
                  ×
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- 标题和正文输入区 -->
      <div class="textarea-section">
        <div class="textarea-item">
          <label>标题</label>
          <textarea
            v-model="formData.title"
            placeholder="请输入标题,字数不能超过45个字"
            maxlength="45"
          ></textarea>
        </div>
        <div class="textarea-item">
          <label>正文</label>
          <textarea
            v-model="formData.content"
            placeholder="请输入正文,字数不能超过150个字"
            maxlength="150"
            rows="6"
          ></textarea>
        </div>
      </div>
      <!-- 按钮组 -->
      <div class="btn-group">
        <button
          class="btn publish-btn"
          @click="handleUpdate"
          :disabled="loading"
        >
          保存修改
        </button>
        <button class="btn save-btn" @click="handleCancel">取消</button>
      </div>

      <!-- element‑plus 图片预览组件 el‑image‑viewer -->
      <el-image-viewer
        v-if="imageViewerVisible"
        :url-list="[currentPreviewUrl]"
        @close="closeImageViewer"
      />
    </div>
  </div>
</template>
<script>
import { ElSelect, ElOption, ElImageViewer } from "element-plus";
export default {
  name: "ProductEditForm",
  components: { ElSelect, ElOption, ElImageViewer },
  props: {
    row: { type: Object, required: true, default: () => ({}) },
  },
  data() {
    return {
      dragItem: null,
      imageViewerVisible: false,
      currentPreviewUrl: "",
      fabricCategoryIds: [],
      listss: [],
      lists: [],
      leilist: [],
      loading: false,
      localRow: {},
      formData: {
        remark: "",
        quantify: "",
        id: "",
        productCode: "",
        width: "",
        weight: "",
        composition: "",
        categoryId: [],
        title: "",
        content: "",
        productpm: "",
        texts: "",
        specification: "",
        yarnCount: "",
        density: "",
        baseProductId: "",
      },
      uploadFiles: {}, // key: _uid 封面固定key:'cover'
      previewUrls: {},
      deletedCover: false,
      details: [],
      colors: [],
      xgtext: "",
      // 文件大小限制
      MAX_COVER_DETAIL_SIZE: 1024 * 1024, // 1MB
      MAX_COLOR_SIZE: 1.3 * 1024 * 1024, //1.3MB
    };
  },
  computed: {
    validDetails() {
      return this.details.filter((item) => !item.deleted);
    },
    validColors() {
      return this.colors.filter((item) => !item.deleted);
    },
  },
  mounted() {
    this.getlistss();
    this.getcp();
    this.getCategoryList().then(() => this.initEditData());
  },
  watch: {
    row: {
      handler(n) {
        if (n && n.id) {
          this.resetForm();
          this.initEditData();
        }
      },
      deep: true,
      immediate: true,
    },
  },
  methods: {
    openImagePreview(url) {
      this.currentPreviewUrl = url;
      this.imageViewerVisible = true;
    },
    closeImageViewer() {
      this.imageViewerVisible = false;
      this.currentPreviewUrl = "";
    },
    // ✅按数组物理顺序赋值sort，从1开始，不再二次排序
    normalizeSort(type) {
      let arr;
      if (type === "detail") arr = this.details;
      else if (type === "color") arr = this.colors;
      else return;
      arr.forEach((item, idx) => {
        item.sort = idx + 1;
      });
    },
    handleDragStart(e, item, type) {
      this.dragItem = { item, type };
      e.dataTransfer.effectAllowed = "move";
    },
    handleDrop(e, targetItem, type) {
      e.preventDefault();
      if (!this.dragItem || this.dragItem.type !== type) return;
      const sourceItem = this.dragItem.item;
      if (sourceItem === targetItem) {
        this.dragItem = null;
        return;
      }
      let list;
      if (type === "detail") list = this.details;
      else if (type === "color") list = this.colors;
      else {
        this.dragItem = null;
        return;
      }
      const sourceIndex = list.findIndex((x) => x === sourceItem);
      const targetIndex = list.findIndex((x) => x === targetItem);
      list.splice(sourceIndex, 1);
      list.splice(targetIndex, 0, sourceItem);
      this.normalizeSort(type);
      this.dragItem = null;
    },
    async getlistss() {
      const userid = this.$store.state.frontUserInfo.id;
      const res = await this.$api.BasicData.get(userid);
      if (res.data.code == 200) {
        this.listss = res.data.data.list;
      } else {
        this.$message.error("网络错误");
        this.listss = [];
      }
    },
    watchs(item) {
      const cpname = item;
      const itemlist = this.lists.filter((item) => item.name == cpname);
      this.formData.width = itemlist[0].width;
      this.formData.baseProductId = itemlist[0].id;
      this.formData.weight = itemlist[0].weight;
      this.formData.composition = itemlist[0].ingredients;
      this.formData.quantify = itemlist[0].quantify;
      this.formData.remark = itemlist[0].remark;
      this.formData.yarnCount = itemlist[0].yarnCount;
      this.formData.density = itemlist[0].density;
      this.formData.specification = itemlist[0].specification;
      if (itemlist[0].fabricCategoryList) {
        let text = "";
        for (
          let index = 0;
          index < itemlist[0].fabricCategoryList.length;
          index++
        ) {
          text += itemlist[0].fabricCategoryList[index].name + ",";
        }
        if (text) text = text.slice(0, -1);
        this.formData.texts = text;
      } else {
        this.formData.texts = "";
      }
      this.fabricCategoryIds = itemlist[0].fabricCategoryList;
    },
    async getcp() {
      const res = await this.$api.BasicData.gets({});
      if (res.data.code == 200) {
        this.lists = res.data.data.list;
      } else {
        this.$message.error("网络错误");
        this.lists = [];
      }
    },
    completeUrlProtocol(url) {
      if (!url || typeof url !== "string") return "";
      if (!url.startsWith("http://") && !url.startsWith("https://")) {
        return `https://${url}`;
      }
      return url;
    },
    async getCategoryList() {
      try {
        const res = await this.$api.shouye.getfl({});
        if (res.data.code == 200 && Array.isArray(res.data.data?.list)) {
          this.leilist = res.data.data.list.map((item) => ({
            id: item.id,
            name: item.name,
          }));
        } else {
          this.$message.error("获取类别列表失败");
        }
      } catch (error) {
        console.error("获取类别列表失败：", error);
        this.$message.error("网络错误，获取类别列表失败");
      }
    },
    initEditData() {
      console.log(this.row, "看看包含了什么数据");

      const d = this.row;
      if (!d) return;
      if (d?.fabricCategoryList) {
        let text = "";
        for (let index = 0; index < d.fabricCategoryList.length; index++) {
          text += d.fabricCategoryList[index].name + ",";
        }
        if (text) text = text.slice(0, -1);
        this.xgtext = text;
      } else {
        this.xgtext = "";
      }
      this.localRow = JSON.parse(JSON.stringify(d));
      this.details = (this.localRow.particularsList || []).map((item) => ({
        _uid: Date.now() + Math.random(),
        id: item.id,
        sort: item.sort,
        url: this.completeUrlProtocol(item.url),
        isNew: false,
        deleted: false,
      }));
      this.colors = (this.localRow.colorcardList || []).map((item) => ({
        _uid: Date.now() + Math.random(),
        id: item.id,
        sort: item.sort,
        url: this.completeUrlProtocol(item.url),
        isNew: false,
        deleted: false,
      }));
      this.formData = {
        id: d.id || "",
        productCode: d.outerKey || "",
        width: d.width || "",
        weight: d.weight || "",
        composition: d.ingredients || "",
        categoryId: (d.categoryList || []).map((item) => item.id),
        title: d.title || "",
        content: d.content || "",
        productpm: d.name || "",
        quantify: d?.quantify || "",
        remark: d?.remark || "",
        specification: d?.specification || "",
        yarnCount: d?.yarnCount || "",
        density: d?.density || "",
        texts: this.xgtext,
        baseProductId: d?.baseProductId,
      };
      if (d.coverUrl) {
        this.previewUrls["cover"] = this.completeUrlProtocol(d.coverUrl);
      }
      this.deletedCover = false;
    },
    // type: cover/detail/color
    // payload: null=新增；item对象=修改已有图片
    handleUpload(type, payload) {
      const fileInput = document.createElement("input");
      fileInput.type = "file";
      fileInput.accept = "image/*";
      // 开启多选
      if (type !== "cover") {
        fileInput.multiple = true;
      }
      fileInput.style.display = "none";
      fileInput.onchange = (e) => {
        const fileList = Array.from(e.target.files);
        if (!fileList.length) return;

        // ===== 单张封面图逻辑不变 =====
        if (type === "cover") {
          const file = fileList[0];
          if (!file.type.startsWith("image/")) {
            this.$message.error("请选择图片格式文件！");
            document.body.removeChild(fileInput);
            return;
          }
          const maxSize = this.MAX_COVER_DETAIL_SIZE;
          if (file.size > maxSize) {
            this.$message.error("图片大小不能超过1MB！");
            document.body.removeChild(fileInput);
            return;
          }
          const blobUrl = URL.createObjectURL(file);
          this.uploadFiles["cover"] = file;
          this.previewUrls["cover"] = blobUrl;
          this.deletedCover = false;
          document.body.removeChild(fileInput);
          return;
        }

        // ========== 详情图 / 电子色卡 批量上传逻辑 ==========
        let targetArr = type === "detail" ? this.details : this.colors;
        const maxCount = 5;
        // 过滤未删除的有效图片
        const validCount = targetArr.filter((item) => !item.deleted).length;
        const remainCount = maxCount - validCount;

        if (remainCount <= 0) {
          this.$message.warning("已达到最大5张上限，不能继续添加！");
          document.body.removeChild(fileInput);
          return;
        }

        // 如果是修改已有图片（payload存在），还是只能单张替换，不批量
        if (payload) {
          const file = fileList[0];
          let maxSize =
            type === "color" ? this.MAX_COLOR_SIZE : this.MAX_COVER_DETAIL_SIZE;
          let tipMsg =
            type === "color"
              ? "图片大小不能超过1.3MB！"
              : "图片大小不能超过1MB！";
          if (file.size > maxSize) {
            this.$message.error(tipMsg);
            document.body.removeChild(fileInput);
            return;
          }
          const blobUrl = URL.createObjectURL(file);
          payload.url = blobUrl;
          payload.isNew = true;
          payload.deleted = false;
          this.uploadFiles[payload._uid] = file;
          document.body.removeChild(fileInput);
          return;
        }

        // 新增：批量添加，只取剩余可上传数量的图片
        const selectFiles = fileList.slice(0, remainCount);
        let maxSize =
          type === "color" ? this.MAX_COLOR_SIZE : this.MAX_COVER_DETAIL_SIZE;
        let tipMsg =
          type === "color"
            ? "图片大小不能超过1.3MB！"
            : "图片大小不能超过1MB！";

        for (const file of selectFiles) {
          if (!file.type.startsWith("image/")) {
            this.$message.error("包含非图片文件，已跳过该文件");
            continue;
          }
          if (file.size > maxSize) {
            this.$message.error(`${file.name}：${tipMsg}`);
            continue;
          }
          const newUid = Date.now() + Math.random();
          const newItem = {
            _uid: newUid,
            id: "",
            sort: 1,
            url: URL.createObjectURL(file),
            isNew: true,
            deleted: false,
          };
          targetArr.push(newItem);
          this.uploadFiles[newUid] = file;
        }
        this.normalizeSort(type);

        // 如果选中图片数量超出剩余空位，提示
        if (fileList.length > remainCount) {
          this.$message.warning(
            `最多只能再上传${remainCount}张，多余图片已忽略`
          );
        }
        document.body.removeChild(fileInput);
      };
      document.body.appendChild(fileInput);
      fileInput.click();
    },

    handleDeleteImage(type, item) {
      if (type === "cover") {
        this.deletedCover = true;
        if (this.previewUrls["cover"]) {
          URL.revokeObjectURL(this.previewUrls["cover"]);
          this.previewUrls["cover"] = "";
        }
      } else {
        item.deleted = true;
        if (item.url.startsWith("blob:")) {
          URL.revokeObjectURL(item.url);
        }
      }
    },
    buildSubmitFormData() {
      // ✅提交前强制刷新sort，保证数组顺序与sort一一对应
      this.normalizeSort("detail");
      this.normalizeSort("color");
      const fd = new FormData();
      const d = this.localRow || {};
      fd.append("product.id", d.id || "");
      fd.append("product.baseProductId", this.formData.baseProductId || "");
      fd.append("product.outerKey", this.formData.productCode || "");
      fd.append("product.width", this.formData.width || "");
      fd.append("product.density", this.formData.density || "");
      fd.append("product.yarnCount", this.formData.yarnCount || "");
      fd.append("product.specification", this.formData.specification || "");
      fd.append("product.weight", this.formData.weight || "");
      fd.append("product.ingredients", this.formData.composition || "");
      this.formData.categoryId.forEach((item, index) => {
        fd.append(`product.categoryIds[${index}]`, item);
      });
      this.fabricCategoryIds.forEach((item, index) => {
        fd.append(`product.fabricCategoryIds[${index}]`, item.id);
      });
      fd.append("product.quantify", this.formData.quantify || "");
      fd.append("product.title", this.formData.title || "");
      fd.append("product.remark", this.formData.remark || "");
      fd.append("product.content", this.formData.content || "");
      fd.append("product.name", this.formData.productpm || "");
      fd.append("product.flag", "0");
      //封面
      if (this.uploadFiles["cover"]) {
        fd.append("product.coverFile", this.uploadFiles["cover"]);
      }
      fd.append("product.coverDelFlag", this.deletedCover ? "0" : "1");
      //详情图
      let detailIdx = 0;
      this.details.forEach((item) => {
        const k = `particularsList[${detailIdx}]`;
        fd.append(`${k}.id`, item.id ?? "");
        fd.append(`${k}.sort`, item.sort);
        fd.append(`${k}.delflag`, item.deleted ? "0" : "1");
        // 通过_uid拿file，不再依赖sort
        if (this.uploadFiles[item._uid]) {
          fd.append(`${k}.file`, this.uploadFiles[item._uid]);
        }
        detailIdx++;
      });
      //色卡图
      let colorIdx = 0;
      this.colors.forEach((item) => {
        const k = `colorcardList[${colorIdx}]`;
        fd.append(`${k}.id`, item.id ?? "");
        fd.append(`${k}.sort`, item.sort);
        fd.append(`${k}.delflag`, item.deleted ? "0" : "1");
        if (this.uploadFiles[item._uid]) {
          fd.append(`${k}.file`, this.uploadFiles[item._uid]);
        }
        colorIdx++;
      });
      return fd;
    },
    async handleUpdate() {
      if (!this.formData.productCode) {
        this.$message.error("产品编号为必填项！");
        return;
      }
      if (this.formData.categoryId.length == 0) {
        this.$message.error("类别为必填项！");
        return;
      }
      if (
        (!this.previewUrls["cover"] || this.deletedCover) &&
        !this.row.coverUrl
      ) {
        this.$message.error("封面图为必填项！");
        return;
      }
      this.loading = true;
      try {
        const fd = this.buildSubmitFormData();
        const res = await this.$api.ProductManage.update(fd, {
          headers: { "Content-Type": "multipart/form-data" },
        });
        if (res.data.code == 200) {
          this.$message.success("修改成功！");
          console.log(fd, "传了什么东西修改成功了");
          this.$emit("update-success");
          this.resetForm();
        } else {
          this.$message.error(`修改失败：${res.data.msg || "接口返回异常"}`);
        }
      } catch (error) {
        console.error("修改失败：", error);
      } finally {
        this.loading = false;
      }
    },
    handleCancel() {
      this.resetForm();
      this.$emit("cancel");
    },
    resetForm() {
      this.formData = {
        id: "",
        productCode: "",
        width: "",
        weight: "",
        composition: "",
        categoryId: [],
        title: "",
        content: "",
        density: "",
        yarnCount: "",
        specification: "",
        baseProductId: "",
      };
      this.details = [];
      this.colors = [];
      this.uploadFiles = {};
      this.previewUrls = {};
      this.localRow = {};
      this.deletedCover = false;
      Object.keys(this.previewUrls).forEach((key) => {
        if (this.previewUrls[key]?.startsWith("blob:")) {
          URL.revokeObjectURL(this.previewUrls[key]);
        }
      });
    },
  },
};
</script>
<style lang="scss" scoped>
@import "./user-product-launch.scss";
.img-item:active {
  opacity: 0.6;
}
.img-show-wrap {
  display: flex;
  gap: 8px;
}
.add-btn {
  flex-shrink: 0;
}
.form-item {
  display: flex;
  align-items: center;
  margin-bottom: 15px;
  label {
    width: 74px;
    text-align: right;
    margin-right: 10px;
    font-size: 14px;
    color: #333;
    flex-shrink: 0;
  }
  input,
  ::v-deep .el-select {
    height: 32px;
    padding: 0 8px;
    border: none;
    border-bottom: 1px solid #999;
    border-radius: 4px;
    font-size: 14px;
    background-color: #fff !important;
  }
}
.single-item {
  width: 100%;
}
.fabric-group {
  margin-top: 56px;
  .group-title {
    font-size: 14px;
    color: #333;
    margin-bottom: 10px;
    font-weight: normal;
  }
}
.form-row {
  display: flex;
  .form-item {
    flex: 1;
    margin-bottom: 15px;
  }
}
.loading-mask {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 9999;
}
.loading-spinner {
  width: 50px;
  height: 50px;
  border: 5px solid #f3f3f3;
  border-top: 5px solid #3498db;
  border-radius: 50%;
  animation: spin 1s linear infinite;
}
@keyframes spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
.publish-btn:disabled {
  background-color: #ccc;
  cursor: not-allowed;
  opacity: 0.8;
}
::v-deep .el-select .el-input__inner {
  background-color: #fff;
}
::v-deep .el-select .el-input__inner:focus {
  background-color: #fff;
}
.upload-box {
  position: relative;
  width: 100px;
  height: 100px;
  border: 1px solid #eee;
  border-radius: 4px;
  overflow: hidden;
  cursor: pointer;
  .uploaded-img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
  .img-mask-edit {
    position: absolute;
    inset: 0;
    background-color: rgba(0, 0, 0, 0.4);
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    gap: 24px;
    opacity: 0;
    transition: opacity 0.2s ease-in-out;
    z-index: 1;
    .mask-btn {
      display: flex;
      flex-direction: column;
      align-items: center;
      cursor: pointer;
    }
    .edit-tip-text {
      color: #fff;
      font-size: 13px;
      margin-top: 4px;
    }
  }
  &:hover .img-mask-edit {
    opacity: 1;
  }
  .img-delete-btn {
    position: absolute;
    top: 4px;
    right: 4px;
    width: 20px;
    height: 20px;
    background: rgba(0, 0, 0, 0.55);
    color: #fff;
    border-radius: 50%;
    text-align: center;
    line-height: 20px;
    font-size: 16px;
    z-index: 2;
  }
}
</style>
